<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="0" tab-position="left" style="background-color: #FFFFFF;height: 85vh">
        <el-tab-pane name="0" label="破产配置">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importGroupCfg" :export-method="exportGroupCfg"/>
                <clear-cache-apply />
                <sync-data />
              </el-row>
            </div>
            <el-table size="mini" :data="groupConfig" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="金币系数" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.moneyCoef" :min="1" placeholder="金币系数" />
                </template>
              </el-table-column>
              <el-table-column label="金币限购" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.moneyLimit" :min="1" placeholder="金币限购" />
                </template>
              </el-table-column>
              <el-table-column label="金币有效期(分)" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.moneyExpire" :min="1" placeholder="金币有效期(分)" />
                </template>
              </el-table-column>
              <el-table-column label="金币档位" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.moneyGear" multiple>
                    <el-option v-for="item in moneyGear" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="体力系数" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.spinsCoef" :min="1" placeholder="体力系数" />
                </template>
              </el-table-column>
              <el-table-column label="体力限购" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.spinsLimit" :min="1" placeholder="体力限购" />
                </template>
              </el-table-column>
              <el-table-column label="体力有效期(分)" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.spinsExpire" :min="1" placeholder="体力有效期(分)" />
                </template>
              </el-table-column>
              <el-table-column label="体力档位" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.spinsGear" multiple>
                    <el-option v-for="item in spinsGear" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button size="mini" type="danger" @click="deleteGroupConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addGroupConfig()">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveGroup()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="1" label="体力不足特惠礼包">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
<!--                <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importGroupCfg" :export-method="exportGroupCfg"/>-->
                <clear-cache-apply />
<!--                <sync-data />-->
              </el-row>
            </div>
            <el-table size="mini" :data="spinsBankruptSpecialOffer" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="价格" align="center">
                <Price :limit-type="[2]" :canFree="false"></Price>
              </el-table-column>
              <el-table-column label="限购" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.limit" :min="1" placeholder="体力限购" />
                </template>
              </el-table-column>
              <el-table-column label="有效期(分)" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.expire" :min="1" placeholder="体力有效期(分)" />
                </template>
              </el-table-column>
              <el-table-column label="优惠率" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.addRatio" :min="1" placeholder="优惠率" />
                </template>
              </el-table-column>
              <el-table-column label="奖励" align="center">
                <template slot-scope="scope">
                  <Reward v-model="scope.row.reward" :limit-type="[15]" ></Reward>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button size="mini" type="danger" @click="deleteSpinsBankruptSpecialOffer($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addSpinsBankruptSpecialOffer()">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSpinsBankruptSpecialOffer()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </template>
  </BasicLayout>
</template>

<script>
import Reward from '@/components/Reward/index.vue'
import CommonExcel from '@/components/CommonExcel'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import Price from "@/components/Price";

export default {
  name: 'Bankrupt',
  components: {Price, SyncData, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      groupConfig: [],
      groupsList: [],
      curClass: 'Bankrupt',
      list: [],
      moneyGear: [
        { id: 1501, name: '档位1(1.99)' },
        { id: 1503, name: '档位2(4.99)' },
        { id: 1504, name: '档位3(9.99)' },
        { id: 1505, name: '档位4(19.99)' },
        { id: 1506, name: '档位5(49.99)' },
        { id: 1507, name: '档位6(99.99)' }
      ],
      spinsGear: [
        { id: 1502, name: '档位1(1.99)' },
        { id: 1508, name: '档位2(4.99)' },
        { id: 1509, name: '档位3(9.99)' },
        { id: 1510, name: '档位4(19.99)' },
        { id: 1517, name: '档位5(49.99)' },
        { id: 1518, name: '档位6(99.99)' }
      ],
      spinsBankruptSpecialOffer:[

      ],
    }
  },
  created() {
    this.initCfg()
  },
  methods: {
    initCfg() {
      getUserTypeAllList().then(res => {
        this.groupsList = [{ name: '默认', id: 0 }]
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
        getCommonCfg({ name: this.curClass }).then(res => {
          this.groupConfig = res.data
        })
        getCommonCfg({ name: "SpinsBankruptSpecialOffer"}).then(res => {
          this.spinsBankruptSpecialOffer = res.data
        })
      })
    },
    deleteGroupConfig(index) {
      this.groupConfig.splice(index, 1)
    },
    addGroupConfig() {
      this.groupConfig.push({ minLv: 1, maxLv: 999, groupIds: [], moneyCoef: 0, spinsCoef: 0, moneyLimit: 1, moneyExpire: 1, spinsLimit: 1, spinsExpire: 1, moneyGear: [], spinsGear: [] })
    },
    importGroupCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.groupConfig = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, moneyGear: this.moneyGear, spinsGear: this.spinsGear }, true, 'name', 'id')
        break
      }
    },
    exportGroupCfg() {
      const fileName = '破产配置'
      const hearer = []
      const excelData = []
      const name = ['破产配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.groupConfig, { groupIds: this.groupsList, moneyGear: this.moneyGear, spinsGear: this.spinsGear }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, {
        minLv: '最小等级', maxLv: '最大等级',
        moneyCoef: '金币系数', spinsCoef: '体力系数',
        groupIds: { name: '用户分组', sub: [] },
        moneyGear: { name: '金币档位', sub: [] },
        spinsGear: { name: '体力档位', sub: [] },
        moneyLimit: '金币限购', moneyExpire: '金币有效期(分)', spinsLimit: '体力限购', spinsExpire: '体力有效期(分)'
      })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    handleSaveGroup() {
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.groupConfig) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    deleteSpinsBankruptSpecialOffer(index) {
      this.spinsBankruptSpecialOffer.splice(index, 1)
    },
    addSpinsBankruptSpecialOffer() {
      this.spinsBankruptSpecialOffer.push({ minLv: 1, maxLv: 999, groupIds: [], reward: [], expire: 1, addRatio: 1, limit: 1, price:0, coin: 1, mtype: 2,bet: 1,sku:"" })
    },
    handleSpinsBankruptSpecialOffer() {
      updateCommonCfg({ name: "SpinsBankruptSpecialOffer", data: JSON.stringify(this.spinsBankruptSpecialOffer) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
  }
}
</script>

<style scoped>
</style>
